import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { NavController, AlertController, ToastController } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { UtilService } from '../../service/util.service';
import { environment } from '../../../environments/environment';
import { UserProfile } from '../../models/user-profile.model';
import { UserData } from '../../providers/user-data';
import { RoleAccess } from '../../models/role-access.model';
import AES = require('crypto-js/aes');
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.page.html',
  styleUrls: ['./customer.page.scss'],
})
export class CustomerPage implements OnInit {

  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };

  baseUrl: any;
  rows: any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  customerList: any[]=[];
  filteredData: any;
  keywordSearch:any='';
  
  roleAccess = new RoleAccess();
  isApproval:boolean=false;

  constructor(
    private storage: Storage,
    private http: HttpClient,
    private navCtrl: NavController,
    private alertController: AlertController,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private userData: UserData,
    private router: Router
  ) {
    this.baseUrl = environment.apiUrl;
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        } 
        this.pageCallback({ offset: this.page.offset });
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable(0);
  }
  
  sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable(0);
  }

  reloadTable(pg:any) {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      if(pg!=0){
        offset = pg;
        this.page.offset = 0;
      }
      const params = new HttpParams()
        .set('token', this.token)
        .set('keyword', this.keywordSearch)
        .set('page', offset.toString());

      this.http.get(this.baseUrl + 'customer', { params })
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        this.page.count = response.results.total;
        this.rows = response.results.data;
        this.filteredData = response.results.data;
        this.customerList = response.data_no_limit;
        let approval= response.approval;
        if(approval.length>0){
          this.isApproval=false;
          for(let i=0;i<approval.length;i++){
            if(approval[i].username==this.userProfile.username){
              this.isApproval=true;
            }
          }
        }
      }, (err) => {
        this.utilService.loadingDismiss();
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }

  goToCustomerCreate() {
    this.navCtrl.navigateForward(['/customer/customer-create']);
  }

  goToUpdatePage(id: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID
      }
    };
    this.navCtrl.navigateForward(['/customer/customer-edit'], navigationExtras);
  }
  goToDetailMember(id: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID
      }
    };
    this.navCtrl.navigateForward(['/customer/customer-detail'], navigationExtras);
  }

  bannedCustomer(customer_id: any,reason:any) {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const params ={
        token:this.token,
        customer_id:customer_id,
        reason:reason,
        username:this.userProfile.username
      }
      this.http.post(this.baseUrl + 'banned-customer', params )
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.showBannedSuccess();
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  async showBannedSuccess() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Berhasil Banned Customer!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.pageCallback({ offset: this.page.offset });
          }
        }
      ]
    });

    await alert.present();
  }
  async showConfirmBanned(id: any) {
    const alert = await this.alertController.create({
      header: 'Banned Customer',
      cssClass: 'custom-alert-class',
      message: 'Masukkan alasan kenapa customer ini di-banned:',
      inputs: [
        {
          name: 'reason',
          type: 'textarea',
          placeholder: 'Contoh: Penyalahgunaan promo, spam, dll',
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'OK',
          handler: (data) => {
            const reason = data && data.reason ? data.reason.trim() : "";

            // Validasi jika kosong
            if (!reason) {
              this.showAlertReasonRequired("Alasan wajib diisi.");
              return false;
            }
            if (reason.length < 10) {
              this.showAlertReasonRequired("Alasan minimal 10 karakter.");
              return false;
            }
            this.showFinalConfirm(id, reason);
          }
        }
      ]
    });

    await alert.present();
  }
  async showAlertReasonRequired(msg: string) {
    const alert = await this.alertController.create({
      header: 'Tidak Valid',
      message: msg,
      buttons: ['OK']
    });

    await alert.present();
  }

  filterDatatable(event) {
    let val = event.target.value.toLowerCase();
    let columnLength = 5;
    let keys = Object.keys(this.customerList[0]);
    this.rows = this.filteredData.filter(function(item){
      for (let i=0; i < columnLength; i++){
        if (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val){
          return true;
        }
      }
    });
    this.page.offset = 0;
  }
  searchCustomer(event) {
    this.keywordSearch= event.target.value.toLowerCase();
    this.reloadTable(1);
  }

  pullCustomer() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const paramsOpts = new HttpParams()
        .set('token', this.token)

      const reqOpts = new HttpHeaders()
        .set('Accept', 'application/json'),
      formData = new FormData();
      formData.append('created_by', this.userProfile.username);

      this.http.post(this.baseUrl + 'customer/pull', formData, { headers: reqOpts, params: paramsOpts })
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.showPullSuccess();
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }

  async showConfirmPull() {
    const alert = await this.alertController.create({
      header: 'Pull Confirmation',
      cssClass:'custom-alert-class',
      message: 'Apakah anda yakin untuk menarik data Customer?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {}
        },
        {
          text: 'OK',
          handler: () => {
            this.pullCustomer();
          }
        }
      ]
    });

    await alert.present();
  }

  async showPullSuccess() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Berhasil tarik data Customer!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.pageCallback({ offset: this.page.offset });
          }
        }
      ]
    });

    await alert.present();
  }
  exportToExcel() {
    let dataForExport = [];
    if(this.customerList.length>0){
      for(let i=0;i<this.customerList.length;i++){
        dataForExport.push(
          { No: (i+1), 
            Name: this.customerList[i].customer_name, 
            "Identity Number": this.customerList[i].identity_number,
            "Phone": this.customerList[i].phone ,
            "Email": this.customerList[i].email ,
            "Registration counter": this.customerList[i].counter_name ,
            "Birth Date":this.customerList[i].birth_date,
            "Address":this.customerList[i].address,
            "Created At":this.customerList[i].created_at,
            "Created By":this.customerList[i].created_by,
            "Updated At":this.customerList[i].updated_at,
            "Updated By":this.customerList[i].updated_by},
        );
      }
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExport);
    const objectMaxLength: number[] = [];
    dataForExport.forEach(row => {
      Object.values(row).forEach((value, colIndex) => {
        const length = String(value).length;
        objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, length);
      });
    });
    Object.keys(dataForExport[0]).forEach((header, colIndex) => {
      objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, header.length);
    });
    ws['!cols'] = objectMaxLength.map(width => ({ wch: width + 2 }));
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Membership.xlsx');
  }
  async showFinalConfirm(id: any, reason: string) {
    const alert2 = await this.alertController.create({
      header: 'Konfirmasi Akhir',
      cssClass: 'custom-alert-class',
      message: `
        Apakah Anda yakin ingin <b>membanned</b> customer ini?<br><br>
          <span class="danger-text"><b>Aksi ini tidak bisa dibatalkan.</b></span><br><br>
        Reason: <i>${reason}</i>
      `,
      buttons: [
        {
          text: 'Tidak',
          role: 'cancel'
        },
        {
          text: 'Ya, Banned',
          handler: () => {
            this.bannedCustomer(id, reason);
          }
        }
      ]
    });

    await alert2.present();
  }
}